import { Configuration } from "@/@core/configuration";

export interface MaintenanceItem {
  startDate: string;
  endDate: string;
  infoStartDate: string;
  infoMessage: {
    fr: string;
    nl: string;
  };
  message: {
    fr: string;
    nl: string;
  };
}

export class Maintenance {
  private static async getMaintenances(): Promise<MaintenanceItem[] | undefined> {
    const maintenances: MaintenanceItem[] = await Configuration.get("maintenances");
    return maintenances && maintenances.length > 0 ? maintenances : undefined;
  }
  public static async getCurrent(): Promise<MaintenanceItem | undefined> {
    const maintenances = await this.getMaintenances();
    return maintenances
      ? maintenances.find(
          m => Date.now() >= new Date(m.startDate).getTime() && Date.now() <= new Date(m.endDate).getTime()
        )
      : undefined;
  }
  public static async getFuture(): Promise<MaintenanceItem | undefined> {
    const maintenances = await this.getMaintenances();
    return maintenances
      ? maintenances
          .filter(m => Date.now() >= new Date(m.infoStartDate).getTime() && Date.now() < new Date(m.endDate).getTime())
          .sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime())[0]
      : undefined;
  }
}
